<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Chargebacks Module</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div class="container header">
					<div class="row">
						<div class="col-12">
							<form class="" [formGroup]="dataSearch" (ngSubmit)="getPayedLeads()">
								<h6><i class="fa fa-search"></i> Chargebacks...</h6>
								<div class="row col-12">
									<div class="form-group col-sm-4">
										<label for="filterNumLead" class="headerSearch"># Lead</label>
										<input formControlName="numLeadP" type="text" class="form-control" id="filterNumLead" placeholder="Type to filter the # Lead column..." (keyup)="updateFilterP($event, 1)" />
									</div>
									<div class="form-group col-sm-4">
										<label for="filterAgent" class="headerSearch">Agent</label>
										<input formControlName="agentP" type="text" class="form-control" id="filterAgent" placeholder="Type to filter the Agent column..." (keyup)="updateFilterP($event, 2)" />
									</div>
									<div class="form-group col-sm-4">
										<label for="filterAlias" class="headerSearch">Alias</label>
										<input formControlName="aliasP" type="text" class="form-control" id="filterAlias" placeholder="Type to filter the Alias column..." (keyup)="updateFilterP($event, 3)" />
									</div>
									<div class="form-group col-sm-4">
										<label for="filterProspect" class="headerSearch">Prospect</label>
										<input formControlName="prospectP" type="text" class="form-control" id="filterProspect" placeholder="Type to filter the Prospect column..." (keyup)="updateFilterP($event, 4)" />
									</div>
									<div class="form-group col-sm-4">
										<label for="filterCampaign" class="headerSearch">Campaign</label>
										<input formControlName="campaignP" type="text" class="form-control" id="filterCampaign" placeholder="Type to filter the Campaign column..." (keyup)="updateFilterP($event, 5)" />
									</div>
									<div class="form-group col-sm-4">
										<label for="filterAmount" class="headerSearch">Amount</label>
										<input formControlName="AmountP" type="text" class="form-control" id="filterAmount" placeholder="Type to filter the Amount column..." (keyup)="updateFilterP($event, 6)" />
									</div>
									<div class="form-group col-sm-4">
										<app-form-range-date formControlName="dateRangeP" (OnSelected)="searchInformation($event)" labelTitle="Select Date range:"></app-form-range-date>
									</div>
									<div class="form-group col-sm-4" style="padding-top: 30px">
										<button class="btn btn-success" (click)="cleanFiltersSearchP()"><i class="fa fa-hand-pointer-o"></i>Clear</button>
										<button type="submit" class="btn btn-primary"><i class="fa fa-search"></i>Search</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
				<br />
				<div class="container" style="height: 100%">
					<div class="row">
						<div class="col-12">
							<ngx-datatable #tablePaid class="material striped" [rows]="rowsPayeds" [columnMode]="columnMode" [loadingIndicator]="loading" [columnMode]="columnMode.force" [headerHeight]="50" [footerHeight]="70" rowHeight="auto" [scrollbarH]="true" [limit]="20">
								<ngx-datatable-column prop="id" name="#" headerClass="title-header" [width]="30"></ngx-datatable-column>
								<ngx-datatable-column prop="generated_by" name="Agent" headerClass="title-header" [width]="55"></ngx-datatable-column>
								<ngx-datatable-column prop="alias" name="Alias" headerClass="title-header" [width]="55"></ngx-datatable-column>
								<ngx-datatable-column prop="prospect_company" name="Prospect" headerClass="title-header" [width]="200"></ngx-datatable-column>
								<ngx-datatable-column prop="campaign_name" name="Campaign" headerClass="title-header" [width]="200"></ngx-datatable-column>
								<ngx-datatable-column prop="date_charged" name="Paid Date" headerClass="title-header" [width]="80">
									<ng-template let-row="row" ngx-datatable-cell-template>
										{{ row["date_charged"] | utcToLocal : "short" }}
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column prop="payed" name="Status" headerClass="title-header" [width]="50">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<span class="badge badge-success" *ngIf="row['payed'] === 'T'">Paid</span>
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column prop="amount" name="Amount" headerClass="title-header" [width]="50">
									<ng-template let-row="row" ngx-datatable-cell-template>
										{{ row["amount"] | currency : "USD" }}
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-column headerClass="title-header" [cellClass]="getContentIcon">
									<ng-template let-row="row" ngx-datatable-cell-template>
										<button class="btn btn-success" (click)="downloadTemplate(row)"><i class="fa fa-hand-pointer-o"></i>Download format</button>
										<!-- <i *ngIf="!dialLoading && row['callbacks'] && row['callbacks'] != 0" (click)="getHotCallbacks(row);" placement="top" ngbTooltip="View Callbacks" class="em em-fire mr-3" style="cursor:pointer;"></i> -->
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-footer *ngIf="true">
									<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
										<div class="title-footer">
											<strong>Total Records: </strong>
											{{ rowCount }}
										</div>
										<div class="title-footer">
											<strong>Total Cost: </strong>
											{{ summaryFor(2) }}
										</div>
										<div class="title-footer pagination">
											<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tablePaid.onFooterPage($event)"> </datatable-pager>
										</div>
									</ng-template>
								</ngx-datatable-footer>
							</ngx-datatable>
						</div>
					</div>
				</div>
				<div class="container" id="leadInfo" style="display: inline; position: fixed">
					<lead-edit *ngIf="idLead != 0" [ID]="idLead"> </lead-edit>
				</div>
			</div>
		</div>
	</div>
</div>
